import { create } from "zustand";
import axiosToken from "../api/axiosClient";
import { toast } from "react-toastify";

const useReservationStore = create((set, get) => ({
    reservations: [],
    isLoading: false,
    error: null,
    reservationsByDateRange: [],
    isLoadingByDateRange: false,

    // Récupérer les réservations par plage de dates
    getReservationsByDateRange: async (startDate, endDate) => {
        if (!startDate || !endDate) {
            toast.error("Dates de début et de fin sont requises.");
            return;
        }

        set({ isLoadingByDateRange: true, error: null });

        try {
            const response = await axiosToken.get(
                `/reservation/date-range?startDate=${startDate}&endDate=${endDate}`
            );
            // console.log(`/reservation/date-range?startDate=${startDate}&endDate=${endDate}`)


            if (response.data.success) {
                // console.log("response.data.data: ", response.data.data)
                set({
                    reservationsByDateRange: response.data.data,
                    isLoadingByDateRange: false
                });
                return response.data.data;
            } else {
                throw new Error(response.data.error || "Erreur lors du chargement des réservations");
            }
        } catch (error) {
            console.error("Erreur getReservationsByDateRange :", error);
            const errorMessage = error?.response?.data?.error || error.message || "Erreur lors du chargement des réservations.";
            toast.error(errorMessage);
            set({ error: errorMessage, isLoadingByDateRange: false });
            return null;
        }
    },


    // Récupérer les réservations du client connecté
    getReservations: async (userId) => {
        if (!userId) {
            toast.error("Utilisateur non connecté.");
            return;
        }

        set({ isLoading: true, error: null });

        try {
            const response = await axiosToken.get(`/reservation/client/${userId}`);
            set({ reservations: response.data.data, isLoading: false });
            return response.data.data;
        } catch (error) {
            console.error("Erreur getReservations :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des réservations.");
            set({ error: error.message, isLoading: false });
            return null;
        }
    }

}));

export default useReservationStore;
